export const MODAL_VERTICAL_PADDING = 8;
export const DEFAULT_MODAL_HEADER_HEIGHT = 49;
export const DEFAULT_TABLE_HEADER_HEIGHT = (isVerticalMode: boolean): number =>
  isVerticalMode ? 53 : 35;
export const TABLE_TITLE_HEIGHT = 41;
export const TABLE_COUNT = 3;
